import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const SizeUnit = z.enum(["Pixels", "Rem", "Percent"]);
export const SizeValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const SizeTokenData = tokenAliasOrValue(SizeValue);
